const reducer = (state, action) => {
    switch (action.type) {
        case 'retrieved':
            return { ...state, ...action.newState, Loading: false };
        case 'clear':
            return {};
        default:
            return state;
    }
};

export default reducer;
